import React from 'react';
import Select from 'react-select';
import { toKebabCase } from '../../util/helpers';
import './VariantSelector.scss';

const VariantSelector = (props) => {
  const {
    option,
    onChange,
    currentValue,
  } = props;
  const {
    name,
    id,
    values,
  } = option;
  const optionValues = values.map(optionValue => ({
    value: optionValue,
    label: optionValue,
  }));
  const setValue = optionValues.filter(optionValue => optionValue.value === currentValue);
  const value = setValue ? setValue[0] : null;
  return (
    <div
      id={id}
      className={`variant-selector ${toKebabCase(name)}`}
    >
      <span className="field-label">{name}</span>
      <Select
        value={value}
        onChange={onChange}
        options={optionValues}
        className="select-control"
        classNamePrefix="select-control"
      />
    </div>
  );
};

export default VariantSelector;
